<select (change)="onRangeChange($event)" [(ngModel)]="selectedRange" class="bg-blue-700 text-xs text-white px-1 h-[38px] font-bold outline-none">
  <option value="Today" class="bg-white text-black "> {{'today' | translate}}</option>
  <option value="Yesterday" class="bg-white text-black ">{{'yesterday' | translate}}</option>
  <option value="Last Week" class="bg-white text-black"> {{'last-week' | translate}}</option>
  <option value="Last Month" class="bg-white text-black">{{'last-month' | translate}}</option>
  <option value="Last Year" class="bg-white text-black ">{{'last-year' | translate}}</option>
  <option value="Custom" class="bg-white text-black ">{{'custom-period' | translate}}</option>
</select>